import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
/** Restyles existing variants without changing the button API or event handlers. */
export default styled(Button)(({ theme, ownerState }) => {
  const {
    palette,
    functions: { pxToRem },
  } = theme;
  const { color, variant, size, iconOnly } = ownerState;
  const tone = palette[color] || palette.white;
  const isBrand = color === "primary" || color === "info";
  const isLight = color === "white" || color === "light" || !palette[color];
  const foreground = isBrand ? palette.brand.ink : isLight ? palette.dark.main : tone.main;
  const filled = variant === "contained" || variant === "gradient";
  const iconSize = size === "small" ? 32 : size === "large" ? 48 : 40;
  return {
    borderRadius: "999px",
    boxShadow: "none",
    backgroundImage: "none",
    ...(filled && {
      background: tone.main,
      color: isBrand || isLight ? palette.dark.main : palette.white.main,
      border:
        "1px solid " + (isBrand ? palette.dark.main : isLight ? palette.grey[400] : tone.main),
      "&:hover": { background: tone.focus || tone.main, boxShadow: "none" },
      "&:disabled": {
        background: tone.main,
        color: isBrand || isLight ? palette.dark.main : palette.white.main,
      },
    }),
    ...(variant === "outlined" && {
      color: foreground,
      border: "1px solid " + (isBrand ? palette.grey[400] : tone.main),
      background: palette.white.main,
      "&:hover": {
        background: palette.surface.alternate,
        borderColor: foreground,
        boxShadow: "none",
      },
      "&:disabled": { color: foreground, borderColor: foreground },
    }),
    ...(variant === "text" && {
      color: foreground,
      background: "transparent",
      "&:hover": { color: foreground, background: palette.surface.alternate },
    }),
    ...(iconOnly && {
      width: pxToRem(iconSize),
      minWidth: pxToRem(iconSize),
      height: pxToRem(iconSize),
      minHeight: pxToRem(iconSize),
      padding: pxToRem(6),
    }),
  };
});
